import { useEffect } from "react";
import PropTypes from "prop-types";
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { getHeightFromMarginBottom, getWidthForAnimation } from "utils";
import { useDeviceCheck } from "hooks";

export const GSAPAnimationMediaVideo = ({
  onScreenAnimation,
  id,
  marginBottom,
  children,
}) => {
  const { isMobile } = useDeviceCheck(1024);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    switch (onScreenAnimation) {
      case "scaleBorder":
        if (!isMobile) {
          onScaleBorder();
        }

        break;
      case "logo":
        onLogo();
        break;
      case "scale":
        onScale();
        break;
      default:
        break;
    }
  }, [isMobile]); //eslint-disable-line

  const onScaleBorder = () => {
    const height = getHeightFromMarginBottom(marginBottom, isMobile);
    const width = getWidthForAnimation();

    gsap
      .timeline({
        scrollTrigger: {
          trigger: `.geco-media.media-${id}`,
          start: `top center`,
          toggleActions: "play none none reverse",
        },
      })
      .fromTo(
        ".top-border, .bottom-border",
        { height: height },
        { height: 0, ease: "cubic-bezier(0.5, 0.35, 0.15, 1)", duration: 1 }
      );

    gsap
      .timeline({
        scrollTrigger: {
          trigger: `.geco-media.media-${id}`,
          start: `top center`,
          toggleActions: "play none none reverse",
        },
      })
      .fromTo(
        ".left-border, .right-border",
        { width: width },
        { width: 0, ease: "cubic-bezier(0.5, 0.35, 0.15, 1)", duration: 1 }
      );
  };

  const onLogo = () => {
    gsap.fromTo(
      `.geco-media_logo.logo-${id}`,
      { opacity: 0, delay: 3 },
      {
        opacity: 1,
        ease: "cubic-bezier(0.5, 0.35, 0.15, 1)",
        duration: 2.5,
      }
    );
  };

  const onScale = () => {
    gsap.fromTo(
      `.geco-media.media-${id}`,
      { scale: 0.9 },
      {
        scale: 1,
        ease: ".5, .35, .15, 1.00",
        scrollTrigger: {
          trigger: `.geco-media.media-${id}`,
          start: "top bottom",
          toggleActions: "play none none reverse",
        },
        onComplete: () => {
          ScrollTrigger.refresh();
        },
      }
    );
  };

  return <>{children}</>;
};

GSAPAnimationMediaVideo.propTypes = {
  onScreenAnimation: PropTypes.string,
  id: PropTypes.string,
  marginBottom: PropTypes.string,
  children: PropTypes.node,
};
